'use client';

import { PressEventsType } from '@osmosis/backend/orm-db';
import { PROD_MEDIA_SERVER } from '@osmosis/constants';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import { H4 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { text3 } from '@osmosis/tailwind-ui/styles/text';
import dayjs from 'dayjs';
import Image from 'next/image';
import React from 'react';
import Link from 'next/link';
import { EVENT_URL } from '../../../constants/urls';
import { titleToUrl } from '../../_lib/shared/events';

type Props = {
  event: PressEventsType;
};

/**
 * Current event item.
 */
const PreviousEventItem = (props: Props) => {
  const { event } = props;

  const formattedTitle = titleToUrl(event.data.title);

  return (
    <Link href={`${EVENT_URL}/${formattedTitle}`}>
      <Box
        id={event.data.anchor_id}
        cn="flex sm:flex-row flex-col sm:gap-4 gap-2 p-2 rounded-lg hover:bg-slate-100 h-full justify-between cursor-pointer"
        data-testid={`previous-event-${event.eventId}-item`}
      >
        <Box data-testid={`previous-event-item-wrapper`}>
          <Box cn="sm:p-0 sm:w-[300px] sm:h-[calc(300px/16*9)] w-full p-[28.25%] relative">
            <Image
              src={`${PROD_MEDIA_SERVER}${event.data.image}`}
              fill={true}
              alt={`Event thumbnail for the ${event.data.title} webinar`}
              className="object-contain object-top"
              // Make sure to adjust these sizes if the image sizes are changed to optimize image
              // performance
              sizes="(max-width: 640px) 90vw, 300px"
            />
          </Box>
        </Box>
        <Box cn="flex-1 flex flex-col gap-1">
          <H3>{event.data.title}</H3>
          <H4 cn={`${text3}`}>{dayjs(event.Date).format('MMMM D, YYYY')}</H4>
          <P>{event.data.description}</P>
        </Box>
      </Box>
    </Link>
  );
};

export default PreviousEventItem;
